import type { FaireProductEntity } from "../../entity_types/product";

export const p_3mdcqpx38e: FaireProductEntity = {
  token: "p_3mdcqpx38e",
  type: "product",
  name: "🌸 Calm & Nourish Bubbly Bath Soak",
  brandToken: "b_ad8bjvlw5g",
  brandName: "Untamed Naturals",
  imageUrl:
    "https://cdn.faire.com/fastly/a0d93cba958d194dfba85501d11e322bf5bb89724fb43202e42db15004a867ae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b4730240315c1ad5e65a450a8c4728360a04b1256e1aacf70b927f495d7845d.jpeg",
  ],
  priceDollars: 12.46,
  description:
    "\nOh hello there silky-smooth skin \n\nThis milky, skin-loving soak is basically like skin treatment in bath. It's the Bubbly Bath Soak you run when your skin is dry, itchy, or you just want it to feel smooth and nourished.\n\nIt bubbles just enough to feel fancy—think soft, playful foam that makes your bath feel like a pampering.\n\n🛁 Perfect for: Soothing dry skin, winding down before bed, and pretending you’re at a luxury spa. Also makes for a family friendly bubble bath with ingredients your little's skin will love.\n\n🌸 Key ingredient benefits:\n\n * \nEpsom Salt – Helps muscles relax and supports magnesium absorption\n\n * \nBaking Soda – Detoxifies, softens, and helps calm skin irritation\n\n * \nCoconut Milk Powder – Deeply hydrates and softens with skin-loving fats\n\n * \nPowdered Oats – Soothes itchiness and helps protect the skin barrier\n\n * \nLavender Essential Oil – Promotes calm, rest, and relaxation\n\n🧪 No weird stuff: Just clean, plant based ingredients that love your body back.",
  tags: [],
  msrpDollars: 22.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:42.751Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
